import { useProdServerAccess } from "../../Hooks/Features/HelpDesk/useProdServerAccess"
import { Dropdown } from "primereact/dropdown";
import { calculateWordsFromString } from "../../utils/Helper";
import _ from "underscore";

const ProdServerAccess = ({ setShowRequestPopup, editData, setEditData, callApi }) => {

    const { popupFilters, setPopupFilters, handleRequestSubmit, loader, options, getServerAccessDetails } = useProdServerAccess({ setShowRequestPopup, editData, setEditData, callApi });

    return (
        <div>
            <div className="w30 mt-2">
                <div className="mt-2">Project Name*</div>
                <Dropdown className="input-dd" options={options?.projects} optionLabel="project_name" value={popupFilters?.project} onChange={(e) => setPopupFilters((prev) => ({ ...prev, project: e.target.value, "approve_by": 0, server: {}}))} placeholder="Project" filter filterInputAutoFocus disabled={!_.isEmpty(editData)}/>
            </div>
            {options?.server?.length > 0 && <div>
                <div className="mt-2">Server*</div>
                <Dropdown className="input-dd" options={options?.server} optionLabel="server_name" display="chip" value={popupFilters?.server} onChange={(e) => {setPopupFilters((prev) => ({ ...prev, server: e.target.value })); getServerAccessDetails(e.target.value, false)}} placeholder="Select Server" style={{ height: "auto" }} filter filterInputAutoFocus />
            </div>}
            {options?.database?.length > 0 && <div>
                <div className="mt-2">Database*</div>
                <div>
                    <Dropdown className="input-dd" options={options?.database} optionLabel="database_name" value={popupFilters?.database} onChange={(e) => setPopupFilters((prev) => ({ ...prev, database: e.target.value }))} placeholder="Select Database" filter filterInputAutoFocus style={{ height: "auto" }}/>
                </div>
            </div>}
            {options?.approveBy?.length > 0 &&
                <div>
                    <div className="mt-2">Approve By*</div>
                    <div className="d-flex flex-wrap gap-1 mt-2" >
                        {options?.approveBy.map((item) => (<div key={item?.user_code}>
                            {item?.user_code !== null &&
                                <div className="d-flex align-items-center">
                                    <input type="radio" id={item?.user_code} name="approve_by" value={item?.user_code} onChange={(e) => setPopupFilters((prev) => ({ ...prev, approve_by: e.target.value }))} checked={parseInt(item?.user_code) === parseInt(popupFilters?.approve_by)} style={{resize: "none"}}/>
                                    <label htmlFor={item?.user_code} name="approve_by">{item?.user_display_name}</label>
                                </div>
                            }
                        </div>
                        ))}
                    </div>
                </div>
            }
            <div>
                <div className="mt-2">Time period*</div>
                <div className="d-flex gap-1">
                    {options?.time?.map((time) => (
                        <div key={time?.value} className={`border p-2 rounded help-desk-popup-roles ${popupFilters?.time?.value === time?.value ? "helpdesk-popup-role-active" : ""}`} onClick={() => setPopupFilters((prev) => ({ ...prev, time: time }))}>
                            <span>{time?.label}</span>
                        </div>
                    ))}
                </div>
            </div>
            <div className="mt-2">Reason for access*</div>
            <div>
                <textarea rows={2} placeholder="Write reason for access" className="w100 form-control border" value={popupFilters?.reason} onChange={(e) => setPopupFilters((prev) => ({ ...prev, reason: e.target.value }))} />
            </div>
            <div className="d-flex justify-content-between">
                {calculateWordsFromString(popupFilters?.reason) <= 5 &&
                    <span className="w20">{calculateWordsFromString(popupFilters?.reason)}/5 words</span>
                }
                <div className="d-flex justify-content-end align-items-center mt-3 w100">
                    <button className="button btn-default" onClick={() => { setShowRequestPopup(false); setEditData({}) }}>Cancel</button>
                    {
                        loader ? <button className="button btn-primary" style={{ width: "60px", height: "30px" }}>
                            <div className="spinner-border" role="status" style={{ width: "20px", height: "20px" }}>
                                <span className="sr-only"></span>
                            </div>
                        </button> :
                            <button className="button btn-primary" onClick={handleRequestSubmit}>Submit</button>
                    }

                </div>
            </div>
        </div>
    )
}

export default ProdServerAccess